import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component, OnDestroy, OnInit,
    ViewChild,
} from '@angular/core';
import { DialogRef } from '../dialog-ref';
import moment from 'moment';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { DialogCloseable } from '../dialog-closeable';
import { FORMAT } from '@core/utils/formats';
import { MOMENT_UNIT } from '@core/utils/moment';
import { ToastService } from '@core/state/toast/toast.service';
import { maxDatetime } from '@shared/validators/max-datetime.validator';
import { minDatetime } from '@shared/validators/min-datetime.validator';
import { DateInputComponent } from '@components/date-input/date-input.component';
import { TranslateModule } from '@ngx-translate/core';
import { ElementsModule } from '@shared/elements/elements.module';
import { DialogTitleComponent } from '../dialog-title.component';
import { DialogBodyComponent } from '../dialog-body.component';
import { DialogActionsComponent } from '../dialog-actions.component';
import { FormValidationModule } from '@components/form-validation/form-validation.module';

@Component({
    selector: 'pay-dialog-date',
    templateUrl: './dialog-date.component.html',
    standalone: true,
    imports: [
        TranslateModule,
        ElementsModule,
        ReactiveFormsModule,
        DialogTitleComponent,
        DialogBodyComponent,
        DialogActionsComponent,
        FormValidationModule
    ],
    host: {
        'class': 'c-dialog active date c-dialog--gutter-xlg',
        '[class.c-dialog--icon]': 'config.icon && config.icon.length > 0',
        '[class.c-dialog--sm]': 'config.small',
        '[class.c-dialog--lg]': '!config.small'
    }
})
export class DialogDateComponent implements OnDestroy, OnInit, DialogCloseable {
    public config;
    public value: string = moment().format(FORMAT.DATETIME_SERVER);
    public minDatetime: string = moment().startOf(MOMENT_UNIT.YEARS).year(1971).format(FORMAT.DATETIME_SERVER);
    public maxDatetime: string = moment().startOf(MOMENT_UNIT.YEARS).year(2038).format(FORMAT.DATETIME_SERVER);
    public changedDate: string;
    public submitted: boolean = false;
    public datetimeForm: FormGroup;
    public isClosing: boolean = false;

    @ViewChild('dateInputComponent') dateInputComponent: DateInputComponent;

    private destroyed$: Subject<void> = new Subject();

    constructor(public dialogRef: DialogRef<DialogDateComponent>,
                private toastService: ToastService,
                private cdr: ChangeDetectorRef) {
        this.config = dialogRef.containerInstance.config;
        this.changedDate = this.value;
    }

    ngOnInit() {
        this.datetimeForm = new FormGroup({
            datetime: new FormControl(this.value, [
                maxDatetime(this.maxDatetime),
                minDatetime(this.minDatetime)
            ])
        });

        this.datetimeForm.valueChanges
          .pipe(
            takeUntil(this.destroyed$)
          )
          .subscribe((value) => {
              this.changedDate = value && value.datetime;
          });
    }

    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
    }

    onCancel() {
        this.dialogRef.close();
    }

    submit() {
        this.submitted = true;
        this.cdr.markForCheck();

        if (!this.datetimeForm.valid) {
            this.toastService.showWarning('Errors.FormInvalid');
        } else {
            this.dialogRef.close(this.changedDate);
        }
    }

    /**
     * Updates the closing status.
     */
    onClose() {
        this.isClosing = true;
        this.cdr.detectChanges();
    }
}
